export enum AlbType {
  Overlapping = 'overlapping',
  Roman = 'roman',
  RomanSideZipper = 'roman_side_zipper',
  Poland = 'poland',
  Surplice = 'surplice',
  American = 'american',
  Monastic = 'monastic',
  V1Roman = 'v1_roman',
  V1NonRoman = 'v1_non_roman',
  V1Surplice = 'v1_surplice',
}
